export default __webpack_public_path__ + "static/media/550.7f1aa29f.png";